module.exports = __webpack_public_path__ + "img/no-collaborators-136px.918e204.png";